import { Bell } from '@liveauctioneers/hammer-ui-core/icons';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { OptionType } from '@liveauctioneers/hammer-ui-core/select';

import SearchFilter from '@/components/Pagination/hammer-pagination/SearchFilter';
import { SortPageSizePair } from '@/components/Pagination/hammer-pagination/SortPageSizePair';
import { sellerSortOrders } from '@/enums';
import { PaginationFilter } from '@/types/PaginationFilter';
import { getNotificationsUrl } from '@/utils/urls';

import filterFavoriteSortOptions from '../helpers/filterFavoriteSortOptions';

type Props = {
    filters: PaginationFilter;
    onFilterChange: (filters: PaginationFilter) => void;
};

const FollowedSellersFilter = ({ filters, onFilterChange }: Props) => {
    const { formatMessage } = useIntl();
    const manageUrl = getNotificationsUrl('auctioneers');

    const mapSortByOptions = (option: string) => {
        const label = formatMessage({ id: option.toLowerCase() });
        return { label, value: option };
    };

    const filteredOptions = filterFavoriteSortOptions(Object.keys(sellerSortOrders));
    const sortByOptions: OptionType[] = filteredOptions.map(mapSortByOptions);

    return (
        <div className="flex items-center justify-between gap-sm border-b border-border-secondary py-lg">
            <div className="flex gap-sm">
                <SearchFilter
                    onChange={onFilterChange}
                    paginationFilter={filters}
                    searchPlaceholder={formatMessage({ id: 'search_auctioneers' })}
                    shouldModifyQueryParams
                />
                <SortPageSizePair
                    className="smMax:hidden"
                    isInsideLabel
                    onChange={onFilterChange}
                    paginationFilter={filters}
                    shouldModifyQueryParams
                    sortOptions={sortByOptions}
                />
            </div>
            <Link
                aria-label="Manage Notifications"
                data-testid="manageNotifications"
                href={manageUrl}
            >
                <InlineButton
                    className="mobile:text-[14px]"
                    icon={Bell}
                    style="neutral"
                >
                    <FormattedMessage id="manageNotifications" />
                </InlineButton>
            </Link>
        </div>
    );
};

export default FollowedSellersFilter;
